module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	"use strict";

	fox.registerWidget('UserOfferNewLogin', {
		configure: function () {
			this.registerOptions('', {
				widgets: {
					form: {
						widget: 'Form',
						formElements: {
							login: {
								element: '[name=login]'
							}
						}
					},
					validator: {
						widget: 'Easy_Form_Validator',
						formWidget: '@parent #form',
						hangClassLocation: 'parentNode',
						requiredFields: ['login'],
						defaultValidator: [{
							validator: 'length',
							options: {min: 1},
							message: 'Cannot be empty'
						}]
					}
				},
				handleWom: {
					setErrorMessage: {
						event: 'formNotValid',
						widget: '#validator',
						callback: 'showError'
					},
					openPopup: {
						event: 'show',
						widget: '@parent',
						callback: 'resetForm',
						params: {
							listenHistory: true
						}
					}
				},
				handleDom: {
					focus: {
						target: 'input[name="login"]',
						event: 'focus',
						callback: 'removeError'
					},
					join: {
						target: '#join',
						event: 'click',
						callback: 'join'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.form = this.wom1('#form');
			this.validator = this.wom1('#validator');
		},

		showError: function(data) {
			this
				.dom1('.error-message')
				.innerText = data.msg;
		},

		removeError: function(el) {
			fox.dom.removeClass('error', el.parentNode);
			this.dom1('.error-message').innerHTML = '';
		},

		join: function() {
			var clientId = this.getOption('clientId');

			if (this.validator.validate() && clientId) {
				var data = this.form.collectData();

				fox.UserOffer.checkAction('purchaseOffer', {
					login: data.login,
					clientId: clientId
				});

				this.setOption('clientId', null);
				this.getParent().hide();
			}
		},

		resetForm: function() {
			this.form.resetForm();
			this.removeError(this.dom1('input[name="login"]'));
		}

	}, 'Widget');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/offer/modelRelated/UserOfferNewLogin.js
// module id = 891
// module chunks = 4